import './NavMenu.css';

import { useAtom } from 'jotai';
import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Drawer, IconButton, Menu, MenuItem } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import {
  authTokenAtom,
  currentUserAtom,
  locationsAtom,
} from '../utils/AtomConfig';
import { Location } from './Location';
import { Refiners } from './Refiners';
import { QuickFilter } from './QuickFilter';

export function NavMenu() {
  const history = useHistory();
  const usernameEl = useRef(null);
  const [, setAuthToken] = useAtom(authTokenAtom);
  const [, setLocations] = useAtom(locationsAtom);
  const [currentUser, setCurrentUser] = useAtom(currentUserAtom);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isShowDrawer, setIsShowDrawer] = useState(false);

  function logout() {
    setIsShowMenu(false);
    setAuthToken('');
    setCurrentUser(null);
    setLocations([]);
    history.replace('/login');
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar 
        position='fixed' 
      >
        <Toolbar
          sx={{
            paddingLeft: '16px !important',
            paddingRight: '16px !important',
            '& a': {
              textDecoration: 'none',
            },
          }}
        >
          <Button
            sx={{
              color: 'white',
              borderColor: 'white',
              minWidth: '42px',
              padding: 1,
              marginRight: 2,
              display: {
                xs: 'inline',
                sm: 'inline',
                md: 'none',
              },
            }}
            color='inherit'
            variant='outlined'
          >
            <MenuIcon onClick={() => setIsShowDrawer(true)} />
          </Button>
          <Link to={'/'}>
            <img
              style={{ width: '200px', marginRight: '14px' }}
              src='./WHC_Logo_REV.svg'
              alt='logo'
            />
          </Link>
          <Box>
            <Link to={'/'}>
              <Typography
                variant='h6'
                sx={{ fontWeight: 800, color: '#ffffff', display: 'inline' }}
              >
                WHITEHAVEN DOCUMENT PORTAL
              </Typography>
            </Link>
          </Box>
          <Location />
          <Typography
            variant='body1'
            component='div'
            ref={usernameEl}
            onClick={() => setIsShowMenu(true)}
            sx={{
              '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
              },
            }}
          >
            {currentUser && currentUser.displayName}
          </Typography>
          <Menu
            anchorEl={usernameEl.current}
            open={isShowMenu}
            onClose={() => setIsShowMenu(false)}
          >
            <MenuItem onClick={() => logout()}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        open={isShowDrawer}
        onClose={() => setIsShowDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            padding: 2,
            backgroundColor: '#ECECF7',
            minWidth: '280px',
          },
        }}
      >
        <Box sx={{ textAlign: 'right' }}>
          <IconButton onClick={() => setIsShowDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Refiners />
        <QuickFilter insideNavBar={true}/>
      </Drawer>
    </Box>
  );
}